<template>
  <v-container fluid>
    <PageHeader no-padding :subtitle="subtitle" />
    <v-tabs v-model="currentTab" dark grow centered>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1">
        <v-icon class="mr-1">compare</v-icon>Guidelines
      </v-tab>
      <v-tab href="#tab-2">
        <v-icon class="mr-1">functions</v-icon>Cofactors
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="currentTab">
      <v-tab-item value="tab-1">
        <TenantGuidelinesManage />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <CoFactorManage />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import TenantGuidelinesManage from '@/components/TenantGuidelinesManage/TenantGuidelinesManage'
  import CoFactorManage from '@/components/CoFactorManage/CoFactorManage'
  export default {
    components: {
      PageHeader,
      TenantGuidelinesManage,
      CoFactorManage,
    },
    data() {
      return {
        currentTab: 'tab-1',
        subtitle: 'Manage guideline to analyte links, cofactor to analyte links, and cofactor calculation strategies.',
      }
    },
  }
</script>

<style lang="stylus">

</style>